const styles = theme => ({
  root: {
    position: 'relative',
    marginTop: 10
  },
  svg: {
    display: 'block',
    position: 'absolute',
    left: 0,
    top: 0
  },
  path: {
    opacity: ({ energy }) => energy.animate ? 0 : 1
  },
  content: {
    position: 'relative',
    zIndex: 10,
    padding: [16, 10, 72]
  },
  socialLinks: {
    margin: [0, 'auto', 10],
    maxWidth: 400
  },
  socialLinksItem: {
    padding: 0,
    height: 20,
    fontSize: 20
  },
  legal: {
    margin: [0, 'auto'],
    padding: 0,
    maxWidth: 400,
    fontSize: 12,
    display: 'none'
  },

  '@media screen and (min-width: 768px)': {
    root: {
      marginTop: 20
    },
    content: {
      padding: [30, 20, 20]
    },
    socialLinks: {
      marginBottom: 20
    },
    socialLinksItem: {
      height: 24,
      fontSize: 24
    },
    legal: {
      display: 'block',
      fontSize: 14
    }
  }
});

export { styles };

// Commit trace: 2025-10-11T12:06:19 - style: fix spacing in Footer.styles.js

// Commit trace: 2025-11-01T09:09:14 - fix: resolve minor issue in Footer.styles.js
